<script>
  import { onMount } from 'svelte';
  import { TS } from '../../config/translation-keys.js';
  import { t9n, set_language } from '../../lib/translate.js';
  import UnauthenticatedLayout from '../../app-shell/guest-app/Layout.svelte';
  import APIClient from '../../state-charts/api-client';

  // component options  ------------------------------------------------------ //

  export let order_uuid = null;
  export let query = {};

  // internal variables ------------------------------------------------------ //

  let order = null;
  let language = null;
  let has_inited = false;
  let is_detail_loaded = false;
  let login_url = '';
  let no_payment;
  let merchant;

  let app_link_ios;
  let app_link_android =
    'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.workpilots.workpilots';

  let label_task;
  let label_type;
  let label_time;
  let label_location;
  let label_amount;
  let label_earning;
  let label_addinfo;
  let share_inorder;
  let login;
  let usemob;

  let details = [
    {
      name: label_task,
      value: '',
    },
    {
      name: label_type,
      value: '',
    },
    {
      name: label_time,
      value: '',
    },
    {
      name: label_location,
      value: '',
    },
    {
      name: label_amount,
      value: '',
    },
    {
      name: label_earning,
      value: '',
    },
    {
      name: label_addinfo,
      value: '',
    },
  ];

  // utility functions -------------------------------------------------------- //

  const translate_texts = () => {
    label_task = t9n(TS.SHARED_ORDER_TASK_LABEL);
    label_type = t9n(TS.SHARED_ORDER_TYPE_LABEL);
    label_time = t9n(TS.SHARED_ORDER_TIME_LABEL);
    label_location = t9n(TS.SHARED_ORDER_LOCATION_LABEL);
    label_amount = t9n(TS.SHARED_ORDER_AMOUNT_LABEL);
    label_earning = t9n(TS.SHARED_ORDER_EARNING_LABEL);
    label_addinfo = t9n(TS.SHARED_ORDER_ADD_INFO_LABEL);
    share_inorder = t9n(TS.SHARED_ORDER_MORE_INFO_TEXT);
    login = t9n(TS.SHARED_ORDER_LOGIN_TEXT);
    login = login.toLowerCase();
    usemob = t9n(TS.SHARED_ORDER_USE_APP_TEXT);
    details[0].name = label_task;
    details[1].name = label_type;
    details[2].name = label_time;
    details[3].name = label_location;
    details[4].name = label_amount;
    details[5].name = label_earning;
    details[6].name = label_addinfo;
  };

  const merchant_country_code = order => {
    return merchant.country_code.toLowerCase();
  };

  const product_for = order => {
    return merchant.products.find(
      p => p.product_id === order.product.product_id
    );
  };

  const load_order = async () => {
    order = await APIClient.get_order_shared(order_uuid);
    merchant = await APIClient.get_merchant_config({
      merchant_uuid: order.merchant_uuid,
    });

    // we need to initially translate text in order to initialize translations
    // otherwise we can't apply another language!
    translate_texts();

    language = merchant_country_code(order);
    set_language(language);
    translate_texts();

    const product = product_for(order);
    const product_name = product.localized_names[`translation_${language}`];
    const currency = merchant.currency_sign;

    no_payment = order.no_payment === true;

    details[0].value = order.details.description;
    details[1].value = product_name;
    details[2].value = order.details.initial_order_time;
    details[3].value = `${order.details.address.city}, ${order.details.address.postal_code}`;
    details[4].value = `${order.details.duration.toFixed(1)} ${t9n(
      order.product.based_on
    )}`;
    details[5].value = `${(
      order.product.worker_price * order.details.duration
    ).toFixed(2)} ${currency}`;
    details[6].value = order.details.additional_info;

    app_link_ios =
      'https://apps.apple.com/' +
      merchant_country_code(order) +
      '/app/workpilots/id1477608018';
    // console.log('share order inject');
    await APIClient.inject_branding(order.merchant_uuid);
  };

  onMount(async () => {
    await load_order();
  });
</script>

<UnauthenticatedLayout route_name="share-order">
  <div id="share-order-page" slot="content" class="container">
    <main class="contained-section">
      <form class="form-shared-order" action="/login" method="post">
        <div class="form-shared-heading center fade-in">
          <div class="logo" />
        </div>

        <div class="form-container">
          <table
            class="table transparent fitscreen order-table fade-in auto-margin">
            {#if !!details}
              {#each details as row, i}
                {#if no_payment && row.name === label_earning}
                  <tr class="hidden" />
                {:else}
                  <tr>
                    <td class="tr-head">
                      <b class="caption">{row.name}</b>
                    </td>
                    {#if row.name === label_task}
                      <td class="td-resp add-info-margin pre-wrap">
                        {#if !!row.value}{row.value}{/if}
                      </td>
                    {:else if row.name === label_addinfo}
                      <td class="td-resp add-info-margin pre-wrap">
                        {#if !!row.value}{row.value}{/if}
                      </td>
                    {:else}
                      <td class="td-resp">
                        {#if !!row.value}{row.value}{/if}
                      </td>
                    {/if}
                  </tr>
                {/if}
              {/each}
            {/if}
          </table>

          <div class="registration center fade-in">
            {share_inorder} &nbsp;
            <a href={`${location.origin}/login`}>{login}</a>
            <br />
            {usemob}
            <br />
          </div>
          <!-- end of .registration -->

          <div class="center fade-in">
            <a href={app_link_ios}>
              <img
                src="/client/assets/app-store-en.png"
                alt="appstore"
                width="170"
                height="51" />
            </a>
            <a href={app_link_android}>
              <img
                src="/client/assets/gp-en.png"
                alt="gpplay"
                width="170"
                height="50" />
            </a>
          </div>
        </div>
        <!-- end of .form-container -->

      </form>
    </main>
  </div>
</UnauthenticatedLayout>

<style>
  html,
  body {
    height: 100%;
  }

  #share-order-page {
    /* todo: this background needs to be branded! */
    background-image: var(--worker-background-image-url);

    /*background-size: 100%;*/
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
  }

  :root {
    --pageMax: 1024px;
    /* shared orderer colors */
    --shared-order-header-color: #ff9800;
    --shared-order-header-line-color: #006699;
    --shared-order-background-color: #ffffffe6;

    /* todo: this logo needs to be branded! */
    --shared-order-logo-url: url('/common/workpilots/images/login-logo.png');
  }

  table {
    margin: 20px;
    /*background: #eef0f0;*/
    width: 90%;
  }

  table.transparent {
    /*background: rgba(255,255,255,0.9)*/
  }

  /* Needed for iOS browser to force breaking of words in the table, otherwise will span table over screen size. Ok with customer. */
  table.fitscreen {
    table-layout: fixed;
  }

  table.fitscreen td {
    word-wrap: break-word;
  }

  table.fitscreen th {
    word-wrap: break-word;
  }

  td {
    color: #7a7676;
    line-height: 20px;
    font-size: 15px;
  }

  tr {
    height: 33px;
  }

  /* Base */
  .container {
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100vw;
    margin: 0;
    /*padding-bottom: 1em;*/
  }

  .contained-section {
    padding: 30px;
    /*width: calc(100vw - 32px);*/
    margin: 0 auto;
    justify-content: center;
    display: grid;
  }

  .form-shared-order {
    width: auto;
    max-width: 700px !important;
    min-width: 600px;
    background-color: var(--shared-order-background-color) !important;
    padding: 10px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }

  .form-shared-heading .logo {
    /*width: 550px;*/
    height: 115px;
    background-image: var(--shared-order-logo-url);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    margin: auto;
  }

  .form-container {
    /*background-color: white;*/
    max-width: 700px;
    margin: auto;
  }

  .registration {
    color: #7a7676;
    font-size: 15px;
    padding: 15px;
  }

  .caption {
    word-break: keep-all;
    white-space: nowrap;
  }

  .center {
    text-align: center;
    margin: 50px;
  }

  .order-table.table > tr > td:first-child {
    width: 25%;
    text-align: right;
    padding-right: 15px;
    padding-left: 20px;
  }

  .fade-in {
    animation: transition_in 1.5s;
  }

  .pre-wrap {
    white-space: pre-wrap !important;
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    table {
      margin: 0;
    }

    td {
      white-space: pre-line;
    }

    .contained-section {
      padding: 5px;
    }

    .form-shared-order {
      min-width: 0;
      padding: 0;
    }

    .center {
      margin: 5px;
    }

    .container {
      min-height: 100%;
    }

    .tr-head {
      display: none;
    }

    .td-resp {
      display: block;
      height: 100%;
      text-align: center;
      border-bottom: none;
    }

    .td-resp:first-child {
      text-align: center;
      border-top: 1px solid #b7b7b7;
    }

    .td-resp:before {
      content: attr(data-heading);
      text-align: center;
    }

    .auto-margin {
      margin: auto;
    }

    .add-info-margin {
      margin-left: 15px;
      margin-right: 15px;
      text-align: center;
    }
  }
</style>
